
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 5h6v6H4V5zm2 2v2h2V7H6zm6 0h15v2H12V7zm-8 6h6v6H4v-6zm2 2v2h2v-2H6zm6 0h15v2H12v-2zm-8 6h6v6H4v-6zm2 2v2h2v-2H6zm6 0h15v2H12v-2z"}})])
          )
        }
      }
    